import React from 'react';
import PropTypes from 'prop-types';
import ProductGroup from '../components/ProductGroup';
import { isFullscreen, cancelFullscreen, getOrderLineElement, getSingleItem } from '../services/utils'


const ListView = (props) => {
const {user, actions, data, showOrderPopup, getOrder, placeOrder, callDH, requestStatusbarData} = props;

let statusbarPrevId = '';

const _onMouseOver = (e) => {
    const products = user.userInfo.products;

    let orderLine = getOrderLineElement(e);

    if (orderLine) {
        let product_id = orderLine.getAttribute('productid');
        let price = orderLine.getAttribute('price');
        let product_currency = orderLine.getAttribute('currency');
        let contract_type = orderLine.getAttribute('contract_type');
        let freights = orderLine.getAttribute('freights');
        const product = getSingleItem(product_id, products);
        let params = {
            currency: product_currency,
            contract_type,
            freights: product.freights
        }
        props.showStatusbar();

        if (statusbarPrevId != product_id) {
            statusbarPrevId = product_id
            requestStatusbarData(product_id, params);
        }
    }
}

const _onMouseOut = (e) => {
    let orderLine = getOrderLineElement(e);

    if (orderLine && orderLine.getAttribute('name') == 'order_line') {
        props.hideStatusbar();
    }
}

const orderHasExpired = () => {
    const { args, getMarketLog } = props;
    getMarketLog(args);
}

const renderOpenGroups = () => {
    const productsShown = {};

    if (!data || !data.length) {
        return null;
    }        
    
    const openGroups = data.filter(group => group.BUY.length
        ? group.BUY[0].status === 'OPEN' 
        : group.SELL[0].status === 'OPEN'
    );

    return openGroups.map((group, i) => {
        const groupProduct = group.BUY.length ? group.BUY[0].product_id : group.SELL[0].product_id;           
        const isFirstForProduct = !productsShown[groupProduct];
        productsShown[groupProduct] = 1;

        return (
            <ProductGroup
                key={'open_group_'+i}
                group={group}
                user={user}
                showOrderPopup={showOrderPopup}
                getOrder={getOrder}
                onMouseOver={_onMouseOver}
                onMouseOut={_onMouseOut}
                placeOrder={placeOrder}
                callDH={callDH}
                isFirstForProduct={isFirstForProduct}
                orderHasExpired={orderHasExpired}
                isFirstItem={i == 0}
                open />
        );
    });
}

const renderClosedGroups = () => {

    if (!data || !data.length) {
        return null;
    }

    const tradedGroups = data.filter(group => group.BUY.length
        ? group.BUY[0].status !== 'OPEN'
        : group.SELL[0].status !== 'OPEN'
    );
    
    return tradedGroups.map((group, i) => {
        return (
            <ProductGroup
                key={'closed_group_'+i}
                group={group}
                user={user}
                showOrderPopup={showOrderPopup}
                getOrder={getOrder}
                onMouseOver={_onMouseOver}
                onMouseOut={_onMouseOut}
                placeOrder={placeOrder}
                callDH={callDH}
                orderHasExpired={orderHasExpired} 
                />
        );

    });
}

return (
    <div>

<div>
    <table className='worklog-table'>
        <tbody>
                <tr key='ListView_1' className='worklog-row worklog-header'>
                    <th className='worklog-row-item worklog-row-header-productname clickable'>
                        <div className='filter-button' onClick={()=>actions.showMarketlogFilter('products', user.userInfo.products)}>
                            Product
                        </div>
                    </th>

                    <th className='worklog-row-item worklog-row-header-tradingperiod'>
                        Period
                    </th>

                    <th className='worklog-row-item worklog-row-header-bid-price sortable'>
                        Bid/Price
                    </th>

                    <th className='worklog-row-item worklog-row-header-quantity'>
                        Bid/Offer Quantity
                    </th>

                    <th className='worklog-row-item worklog-row-header-offer-price sortable'>
                        Offer/Price
                    </th>
                    
                    <th className='worklog-row-item worklog-row-header-otccme clickable'>
                        <div className='filter-button' onClick={()=>actions.showMarketlogFilter('contract_type')}>
                            Contract Type
                        </div>
                    </th>                                                                                            
                    { user.isAdmin || user.isSuperUser ?
                    <th className='worklog-row-item worklog-row-header-counterpart'>
                        Buyer Company
                    </th>
                    : null }                                
                    <th className='worklog-row-item worklog-row-header-expires'>
                        Bid Expires
                    </th>
                    { user.isAdmin || user.isSuperUser ?
                    <th className='worklog-row-item worklog-row-header-counterpart'>
                        Seller Company
                    </th>
                    : null }                                
                    <th className='worklog-row-item worklog-row-header-expires'>
                        Offer Expires
                    </th>
                </tr>
                <tr  key='ListView_2' className='group-separator' />
                {renderOpenGroups()}
            </tbody>
            </table>
        </div>
        
        <br /><br /><br />

        <div className='worklog-content'>
            <table className='worklog-table'>
            <tbody>
                <tr  key='ListView_3' className='worklog-row worklog-header'>
                    <th className='worklog-row-item worklog-row-header-intent'>
                        Your action
                    </th>
                    <th className='worklog-row-item worklog-row-header-productname clickable'>
                        <div className='filter-button' onClick={()=>actions.showMarketlogFilter('products', user.userInfo.products)}>
                            Product
                        </div>
                    </th>
                    <th className='worklog-row-item worklog-row-header-price sortable'>
                        Price
                    </th>
                    <th className='worklog-row-item worklog-row-header-tradingperiod sortable'>
                        Period
                    </th>
                    <th className='worklog-row-item worklog-row-header-quantity sortable'>
                        Quantity
                    </th>
                    <th className='worklog-row-item worklog-row-header-otccme clickable'>
                        <div className='filter-button' onClick={()=>actions.showMarketlogFilter('contract_type')}>
                            Contract Type
                        </div>
                    </th>                                                                                            
                    { user.isAdmin || user.isSuperUser ?
                    <th className='worklog-row-item worklog-row-header-counterpart sortable'>
                        Company
                    </th>
                    : null }                                
                    <th className='worklog-row-item worklog-row-header-expires sortable'>
                        Expires
                    </th>
                </tr>
                <tr  key='ListView_4' className='group-separator' />
                {renderClosedGroups()}
                </tbody>
            </table>
        </div>
    </div>
)}

export {ListView};



// WEBPACK FOOTER //
// ./source/components/OnlineMarketsListView.js